/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPayersForCustomerRequest} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'
import {GetPayersForCustomerResponse} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'


export const getPayersForCustomer = (request: GetPayersForCustomerRequest, options?: CashRequestOptions) => post<GetPayersForCustomerRequest, GetPayersForCustomerResponse>("/2.0/cash/get-payers-for-customer", request, {...options, rejectOnError: true })